import { listen, unlisten } from './invokeNative'
import { invokeNative } from '../common'

export default {
  created() {
    
    unlisten('onGetPageLevel');
    listen('onGetPageLevel',(res)=>{
      console.log(this)
      if(+this.pageLevel){
        console.log('游戏询问PageLevel');
        invokeNative('setPageLevel',{
          pageLevel:this.pageLevel,
        },(res)=>{
        },(res)=>{
        });
      }
      
    })

    
  },
  beforeDestroy(){
    
  }
}
